import { useCallback, useMemo } from 'react';
import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBCultureSelectedSoilCP,
  setSoilCP,
} from 'redux/reducers/meteorologyAgroWBCultureReducer';
import useOptions from './useOptions';

export default function useSoil() {
  const { options } = useOptions();
  const soilTypes = useMemo(() => options?.soilTypes, [options]);

  const selectedSoil = useSelector(selectMeteorologyAgroWBCultureSelectedSoilCP);
  const setSoil = useCallback((c: number) => {
    store.dispatch(setSoilCP(c));
  }, []);

  return {
    soilTypes,
    selectedSoil,
    setSoil,
  };
}
